import React, { Component } from 'react'
import './ButtonPrimary.css'

export default class ButtonPrimary extends Component {
    render() {
        return (
            <button {...this.props} className={"btn-tertium-primary "+this.props.className}>{ this.props.children }</button>
        )
    }
}